const siteSettings = {
  // Change to "modern" or "classic" to switch hero design.
  heroVariant: "modern",
};

export default siteSettings;
